import { memo } from "react";
import { VehicleSpecsCardProps } from "./types";
import { InfoCard, InfoGrid, Section } from "../primitives";

// Tehničke specifikacije vozila — isti raspored kao ListingVehicleSpecs na detalju oglasa.
const VehicleSpecsCard: React.FC<VehicleSpecsCardProps> = ({ formValues }) => {
  const type = formValues.vehicleType ?? null;

  const power = formValues.kw != null
    ? `${formValues.kw} kW${formValues.hp != null ? ` / ${formValues.hp} KS` : ""}`
    : null;

  const displacement = formValues.cylinderCapacity
    ?? (type?.cylinderCapacity ? String(type.cylinderCapacity) : null);

  return (
    <Section title="Tehničke specifikacije">
      <InfoGrid columns={3}>
        <InfoCard label="Motor (gorivo)" value={formValues.fuelType ?? type?.fuelType?.name} />
        <InfoCard label="Snaga motora" value={power} />
        <InfoCard label="Radni obujam (cm³)" value={displacement ? `${displacement} cm³` : null} />

        <InfoCard label="Vrsta mjenjača" value={type?.transmission?.name} />
        <InfoCard label="Vrsta pogona" value={type?.drivenWheels?.name} />
        <InfoCard label="Oblik karoserije" value={type?.bodyCode} />

        <InfoCard label="Broj vrata" value={type?.numberOfDoors} />
        <InfoCard label="Broj sjedala" value={type?.seats} />
        <InfoCard label="Boja" value={formValues.colorName} />

        <InfoCard
          label="Prijeđeni kilometri"
          value={formValues.kmTraveled != null ? `${formValues.kmTraveled.toLocaleString("hr-HR")} km` : null}
        />
        <InfoCard label="Godina modela" value={formValues.vehicleModel?.year} />
        <InfoCard label="Tip" value={type?.name} />
      </InfoGrid>
    </Section>
  );
};

export default memo(VehicleSpecsCard);
